import _default from './Reveal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Reveal/index.js
// module id = 2713
// module chunks = 1